if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
        const observer = new MutationObserver((MutationList) => {
            // console.log(MutationList)
            for (let item of MutationList) {
                if (item.target.classList.contains("cart-bubble__text-count") || item.target.localName === "shopify-paypal-button") {
                    setTimeout(()=>{
                        BSS_B2B.observer.cartSubject.notifyObserver('CartMutate', 'CartPriceMutate');
                    }, 2000)
                   
                }
            }
        })
        observer.observe(document.body, {
            childList: true,
            subtree: true
        })
    }, 300)
}